<nav class="side-nav" [attr.aria-label]="'Main navigation' | translate">
  <div class="brand">
    <img src="assets/imgs/mitter-m.png" width="36" height="36" alt="" />
    <span class="brand-name">Mitter <span class="brand-sub">Comercio</span></span>
  </div>

  <ul class="group">
    <li *ngFor="let item of daily; trackBy: trackByUrl">
      <a
        class="link"
        [routerLink]="item.url"
        routerDirection="root"
        routerLinkActive="active"
        #active="routerLinkActive"
        [attr.aria-current]="active.isActive ? 'page' : null"
      >
        <ion-icon [name]="item.icon" aria-hidden="true"></ion-icon>
        <span>{{ item.label | translate }}</span>
      </a>
    </li>
  </ul>

  <p class="group-title" id="side-nav-business">{{ 'My business' | translate }}</p>
  <ul class="group" aria-labelledby="side-nav-business">
    <li *ngFor="let item of business; trackBy: trackByUrl">
      <a
        class="link"
        [routerLink]="item.url"
        routerLinkActive="active"
        #active="routerLinkActive"
        [attr.aria-current]="active.isActive ? 'page' : null"
      >
        <ion-icon [name]="item.icon" aria-hidden="true"></ion-icon>
        <span>{{ item.label | translate }}</span>
      </a>
    </li>
  </ul>

  <button type="button" class="link theme" [attr.aria-pressed]="theme.dark" (click)="theme.toggle()">
    <ion-icon [name]="theme.dark ? 'sunny-outline' : 'moon-outline'" aria-hidden="true"></ion-icon>
    <span>{{ 'Dark theme' | translate }}</span>
    <span class="switch" aria-hidden="true"><span class="knob"></span></span>
  </button>

  <button type="button" class="link logout" (click)="logout()">
    <ion-icon name="log-out-outline" aria-hidden="true"></ion-icon>
    <span>{{ 'Logout' | translate }}</span>
  </button>
</nav>
